import { Component, Input, OnInit } from '@angular/core';
import { OpenFieldMetadataLego } from '../../shared/dto/open-field-metadata.lego';
import { OpenFieldTypeEnum } from '../../shared/dto/open-field-type.enum';

@Component({
  selector: 'wl-open-field-lego-edit',
  templateUrl: './open-field-lego-edit.component.html',
  styleUrls: ['./open-field-lego-edit.component.less'],
    standalone: false
})
export class OpenFieldLegoEditComponent implements OnInit {
  @Input() openFieldData: OpenFieldMetadataLego;
  openFieldType = OpenFieldTypeEnum;

  constructor() {}

  ngOnInit(): void {}

  primeChipCompleteMethod() {}
}
